/**
 * GetSubscriptionsUseCase
 * Use case for fetching subscriptions with pagination
 */

import type { PageCursor } from '@/data/types/json';
import { SubscriptionService } from '@/domain/services/subscription/subscriptionService';
import { ExclusiveContentSubscriptionRemapper } from '@/domain/remappers/exclusiveContentSubscription/exclusiveContentSubscriptionRemapper';
import type { ExclusiveContentSubscriptionEntity } from '@/domain/entities/exclusiveContentSubscription/exclusiveContentSubscriptionEntity';

export class GetSubscriptionsUseCase {
  private subscriptionService: SubscriptionService;

  constructor() {
    this.subscriptionService = SubscriptionService.getInstance();
  }

  async execute(
    currentUserId: string,
    cursor?: PageCursor,
    limit?: number,
    meSubscriber?: boolean | null
  ): Promise<{
    subscriptions: ExclusiveContentSubscriptionEntity[];
    hasMore: boolean;
    cursor?: PageCursor;
  }> {
    const result = await this.subscriptionService.getExclusiveContentSubscriptions(
      currentUserId,
      cursor,
      limit,
      meSubscriber
    );

    return {
      subscriptions: ExclusiveContentSubscriptionRemapper.fromDtoList(
        ExclusiveContentSubscriptionRemapper.fromJsonList(result.items)
      ),
      hasMore: result.hasMore,
      cursor: result.cursor,
    };
  }
}

export const createGetSubscriptionsUseCase = () => new GetSubscriptionsUseCase();
